import { atomWithImmer } from 'jotai-immer';

const uiState = atomWithImmer({
  isHeaderTransparent: true,
  isZenDeskOpen: false,
});

export default uiState;
